import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import React from "react";
import { formatGeDateTime } from "../../dates";

function OrderAdditionalServicesList() {
  const { order, loading } = useOutletContext();

  return (
    <Box>
      {order.services.map((service, index) => (
        <OrderAdditionalServiceItem service={service} index={index} />
      ))}
    </Box>
  );
}

function OrderAdditionalServiceItem({ service, index }) {
  const { t, i18n } = useTranslation();

  const date = formatGeDateTime(service.date);
  const serviceDescription = service.getName(i18n.language);
  const cost = `${service.amount} ${t("orderTracking.gel")}`;
  const paymentSide = service.payment_by_sender
    ? t("orderCreation.paymentSender")
    : t("orderCreation.paymentRecipient");

  return (
    <Box className={"mx-6"}>
      <Box>
        <Typography className={"font-bold my-3"}>{serviceDescription}</Typography>
        <Box className={"flex my-3"}>
          <Typography variant={"subtitle1"} className={"text-gray-500 mr-2"}>
            {t("orderTracking.additionalServices.date")}:
          </Typography>
          <Typography variant={"subtitle1"}>{date}</Typography>
        </Box>
        <Box className={"flex my-3"}>
          <Typography variant={"subtitle1"} className={"text-gray-500 mr-2"}>
            {t("orderTracking.additionalServices.cost")}:
          </Typography>
          <Typography variant={"subtitle1"}>{cost}</Typography>
        </Box>
        <Box className={"flex my-3"}>
          <Typography variant={"subtitle1"} className={"text-gray-500 mr-2"}>
            {t("orderTracking.additionalServices.paymentBy")}:
          </Typography>
          <Typography variant={"subtitle1"}>{paymentSide}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderAdditionalServicesList;
